import './style.scss';
import BtnSimple from '@fava/Button/Simple';
import { FC, MouseEvent } from 'react';

interface IProgram {
  id?: number;
  img: any;
  module: number;
  title: string;
  description?: string;
  onclick?: (e: any) => void;
  onConsult?: (id?: number) => void;
}

const Program: FC<IProgram> = ({
  id,
  img,
  module,
  title,
  description,
  onclick,
  onConsult,
}) => {
  const handleClick = (e: any) => {
    if (onclick) {
      e.preventDefault();
      e.stopPropagation();
      onclick(id);
    }
  };

  const handleConsult = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (onConsult) {
      onConsult(id);
    }
  };

  if (onConsult) {
    return (
      <div
        className={`card-program-admin ${onclick && 'cursor-pointer'}`}
        onClick={handleClick}
        style={{ overflow: 'visible', display: 'block', padding: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
          <div style={{ flexShrink: 0 }}>
            <img
              src={img}
              alt={title}
              className="card-program-img"
              style={{ width: '6rem', height: '6rem' }}
            />
          </div>

          <div className="card-program-content-admin" style={{ marginLeft: 0, minWidth: 0, flex: 1 }}>
            <h3 style={{ margin: 0 }}>Module {module}</h3>
            <h1 style={{ margin: '4px 0' }}>{title}</h1>
            {description && (
              <p style={{ margin: 0 }}>
                {`${description}`.substring(0, 100)}
                {`${description}`.length > 100 && '...'}
              </p>
            )}
          </div>
        </div>

        <div style={{ marginTop: '14px', display: 'flex', justifyContent: 'flex-end' }}>
          <BtnSimple
            borderRadius={false}
            backgroundColor="#615EFF"
            onClick={handleConsult}>
            Consulter
          </BtnSimple>
        </div>
      </div>
    );
  }

  return (
    <div className={`card-program-admin ${onclick && 'cursor-pointer'}`} onClick={handleClick}>
      <div className="root-center-flex-start">
        <div>
          <img src={img} alt={title} className="card-program-img" />
        </div>

        <div className="card-program-content-admin">
          <div className="root-space-between">
            <div>
              <h3>Module {module}</h3>

              <h1>{title}</h1>

              {description && (
                <p>
                  {`${description}`.substring(0, 100)} {`${description}`.length > 100 && '...'}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Program;
